import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FileUploadResult } from '@innovationnorway/cl-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SivaBudgetAttachmentType, SivaService } from 'src/api/v2';
import { SIVA_BUDGET_ATTACHMENTS_KEY } from 'src/constants/hook-keys';

export function useSivaBudgetAttachmentsMutations() {
  const [service] = useState(() => new SivaService());
  const queryClient = useQueryClient();
  const { t: tError } = useTranslation('error');

  return {
    upload: useMutation({
      mutationFn: async ({
        type,
        file,
        year,
      }: {
        type: SivaBudgetAttachmentType;
        file: File;
        year: number;
      }): Promise<FileUploadResult> => {
        try {
          const result = await service.budgetUpload(type, year, {
            data: file,
            fileName: file.name,
          });
          return { status: true, message: result.name ?? undefined };
        } catch (_e: any) {
          if (_e.Status === 422) {
            return { status: false, message: tError('malwareDetected') };
          }
          return { status: false, message: tError('somethingWentWrongTryAgain') };
        }
      },
      onSuccess: (result) => {
        if (result.status) {
          queryClient.invalidateQueries([SIVA_BUDGET_ATTACHMENTS_KEY]);
        }
      },
    }),
    download: useMutation({
      mutationFn: async (attachmentId: string) => {
        return await service.budgetDownload(attachmentId);
      },
    }),
    delete: useMutation({
      mutationFn: async (atttachmentId: string) => {
        return await service.budgetDelete(atttachmentId);
      },
      onSuccess: () => {
        queryClient.invalidateQueries([SIVA_BUDGET_ATTACHMENTS_KEY]);
      },
    }),
  };
}
